import React, { useEffect, useState } from "react";
import FrontVideo from "../../components/homevideo";
import HeaderTitle from "../../components/headerTitle";
import { API_BASE_URL } from "../../config/config";
import axios from "axios";
import WhatWeOffer from "../../components/CommonSections/WhatWeOffer";
import Advantage from "../../components/CommonSections/Advantage";
import PageLoader from "../../components/home/pageload";
import ClientExperiences from "../../components/home/client-experiences";
import MetaTag from "../../components/CommonSections/MetaTag";
import ImgUnifiedCommunications from "../../assest/images/IshanUnified Communications.png";
import { Link } from "react-router-dom";
import SubServiceSchema from "../../components/CommonSections/subServicesSchema";
import InternetServiceSec from "../../components/interner-service";
 
import {
     Input,
     FormFeedback,
     Form, 
     Modal,
     ModalBody,
   } from "reactstrap";


export default function UnifiedCommunications() {

     const handleClick = () => {
          window.scrollTo(0, 0);
     }
     const [unifiedCommunicationData, setUnifiedCommunicationData] = useState(null);
     const [settingResponse, setSettingResponse] = useState(null);

     useEffect(() => {
          const requestData = {
               "service_tag": "managesdwan_services"
          };

          axios.post(`${API_BASE_URL}/api/unifiedservices/getUnifiedservices`, requestData).then((response) => {
               setUnifiedCommunicationData(response);

               const generalSettingsData = response?.data?.data?.general_settings?.general_settings_data;

               const networkServicesSettingsData = generalSettingsData.find((item) => item.tag === "managesdwan_services") || null;
               const networkServicesSettingsResponse = JSON.parse(networkServicesSettingsData?.response || "{}");

               setSettingResponse(networkServicesSettingsResponse);
          }).catch((error) => {
               <PageLoader />
          })
     }, [])

     const [getInTuchPlanModal, setInTuchPlanModal] = useState(false);
     const planGetIntuchToggle = () => {
       if (getInTuchPlanModal) {
          setInTuchPlanModal(false);
       } else {
          setInTuchPlanModal(true);
       }
     };
    
   
     const openGetInTuchPlanModal = () => {
          setInTuchPlanModal(true);
     };
   
     return (

          <>
               {unifiedCommunicationData === null ? (
                    <PageLoader />
               ) : (
                    <>
                    <SubServiceSchema title={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                              [0].title} url='https://ishantechnologies.com/cybersecurity-services/managed-sase' parentTitle='Network Services' parentUrl='https://ishantechnologies.com/network-services' />
                    <MetaTag data={unifiedCommunicationData} pageKey="unified_services"/>
                         <div className="page_heading responsive_heading"> 
                              <div className="container">
                                   <HeaderTitle headerTitledata={unifiedCommunicationData} pageKey="unified_services" />
                              </div> 
                         </div>
                         <div 
                              className={`video hero-banner internet-banner ${
                              !unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                                            [0]?.banner_title &&!unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                                            [0].banner_img_desc 
                                   ? 'no-content' 
                                   : ''
                              }`}
                              >
                              <FrontVideo homeData={unifiedCommunicationData} pageKey="unified_services" />

                              <div className="banner-content ">
                                   <div className="content-blk">
                                        {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0]?.banner_title && (
                                        <h2 className='home-heading'>
                                             {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0].banner_title}
                                        </h2>
                                        )}

                                        {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0]?.banner_img_desc && (
                                        <p className="para">
                                             {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0].banner_img_desc}
                                        </p>
                                        )}

                                        {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0]?.button_img_name && (
                                        <a href={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0].button_url}>
                                             <button className="button hero-btn">
                                             {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_banner_data
                                        [0]?.button_img_name}
                                             </button>
                                        </a>
                                        )}
                                   </div>
                                   <div className="form-blk">
                                        <InternetServiceSec homeData={unifiedCommunicationData} pageName="managed-sdwan" />
                                   </div>
                              </div>  
                         </div>
                         <div className="empowering section-space spin-wrap">
                              <div className="spin-round-wrap">
                                   <div className="spin-round color-navy-blue">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>

                              <div className="container">
                                   <div className="empowering-inner">
                                        <div className="empowering-left">
                                             {<img src={ImgUnifiedCommunications} alt="Unified Communications" height={60} width={60} loading="lazy"/>}
                                        </div>
                                        <div className="empowering-right" dangerouslySetInnerHTML={{ __html: unifiedCommunicationData?.data?.data?.unified_services?.unified_services_information_data[0]?.description }}>
                                        </div>
                                   </div>
                              </div>

                              <div className="spin-round-wrap">
                                   <div className="spin-round">
                                        <span className='ballDot1'>1</span>
                                        <span className='ballDot2'>2</span>
                                        <span className='ballDot3'>3</span>
                                        <span className='ballDot4'>4</span>
                                   </div>
                              </div>
                         </div>

                         <div className="weoffer-bgdark">
                              <WhatWeOffer title={settingResponse?.what_we_offer} data={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_offer_data} />
                         </div> 

                         <Advantage title={settingResponse?.advantages} data={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_advantages_data} />


                         <div className="client-experiences section-space">
                              <ClientExperiences homeData={unifiedCommunicationData} pageKey="unified_services" tag="unified_communication" />
                         </div>


                         <div className="supercharge supercharge-left">
                              <div className="container">
                                   <h2 className="supercharge-heading">{unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.title}</h2>
                                   <div className="supercharge-btns">

                                        {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_title_1 &&
                                             <Link to={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_url_1}>
                                                  <button className="getintouch" onClick={handleClick}>{unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_title_1?.toUpperCase()}</button>
                                             </Link>
                                        }
                                        {unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_title_2 &&
                                             <Link to={unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_url_2} target="_blank">
                                                  <button className="getintouch" onClick={handleClick}>{unifiedCommunicationData?.data?.data?.unified_services?.unified_services_cta_banner_data[0]?.button_title_2?.toUpperCase()}</button>
                                             </Link>
                                        }
                                   </div>
                              </div>
                         </div>

                          <Modal isOpen={getInTuchPlanModal} toggle={getInTuchPlanModal}>
                              <ModalBody>
                                   <Link className="close1" onClick={(e) => { e.preventDefault(); planGetIntuchToggle(); }}>×</Link>
                                        <div className="Mobile_getin_tuch">
                                             <InternetServiceSec homeData={unifiedCommunicationData} pageName="managed-sdwan" />
                                        </div>
                                   </ModalBody>
                              </Modal>
                         
                         <a href="javascript:void(0)" className="enquire-now-side-btn" onClick={() => openGetInTuchPlanModal()}>GET IN TOUCH</a>
                         
                    </>
               )}
          </>
     );
}